<div on:click>
  <i></i>
  <i></i>
  <i></i>
</div>


<style>
  div {
    position: relative;
    display: flex;
    justify-content: right;
    padding-right: 30px;
  }

  div::before {
  	position: absolute;
  	right: 0;
  	height: 40px;
  	width: 20px;
  	border-top-left-radius: 100px;
  	border-bottom-left-radius: 100px;
  	background-color: #3d0e28;
  }

  div:hover i::after {
    border-color: #3d0e28;
  }

  div:hover i:first-of-type::after {
    animation: blink_two 1s;
  }

  div:hover i:first-of-type + i::after {
    animation: blink_one 1s;
  }

  div:hover::before {
    	content: '';
  }

  i {
    box-sizing: border-box;
    position: relative;
    display: block;
    width: 25px;
    height: 25px;
    border: 2px solid transparent;
    border-radius: 100px
  }

  i::after {
    content: '';
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 30px;
    height: 30px;
    border-bottom: 2px solid;
    border-right: 2px solid;
    transform: rotate(-45deg);
    right: 6px;
    top: 4px
  }

  i:first-of-type::after {
    border-color: transparent;
  }

  @keyframes blink_one {
    0%   { border-color: transparent; }
    33%  { border-color: inherit; }
  }

  @keyframes blink_two {
    0%   { border-color: transparent; }
    66%  { border-color: inherit; }
  }
</style>
